(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifFooter', swifFooter);

    /**
     * @ngdoc directive
     * @name swif.ui:swifFooter
     * @module swif.ui
     * @restrict E
     * @description display the footer of the app
     **/
    function swifFooter(settings, userService) {
        'ngInject';
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'partials/ui/footer.html',
            link: function (scope, element) {
                scope.app = settings.app;
                scope.description = 'Logiciel de Gestion des services techniques';
                scope.settings = settings;
                var watched = 'settings.localStorage.' + settings.app.db + '.authenticated_user_data';
                scope.$watch(watched, function (newV) {
                    if (newV != scope.authenticatedUserData && newV !== undefined) {
                        scope.authenticatedUserData = newV;
                        var isCitizen = !_.contains(newV.access_rights, 'openstc_full_view');
                        scope.showCGU = settings.app.modules.opengst_mobile && isCitizen;
                    } else {
                        scope.showCGU = false;
                    }
                })
            }
        };
    }

})();

function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

var footerTop = 0
function footerAlwayInBottom(footerSelector) {
    var docHeight = window.innerHeight;
    if(footerTop === 0){
      footerTop = footerSelector.offsetTop + window.scrollY + footerSelector.offsetHeight;
    }
    if (footerTop < docHeight) {
      footerSelector.style.marginTop = (docHeight - footerTop) + "px";
    }
}

window.onresize = function(){
  footerAlwayInBottom(document.querySelector('#footer-navbar'));
};
window.setTimeout(function() {
  footerAlwayInBottom(document.querySelector('#footer-navbar'));
}, 500);
